export interface SdkConfig {
  siteKey: string;
  endpoint: string;
  pageTitle?: string;
}

/**
 * SDKを読み込んだscriptタグから接続設定と任意の記事タイトルを返す。
 * 空白だけのタイトルは属性なしと同じ形へ正規化し、記事DOMへのフォールバックはMetaReaderへ一任する。
 */
export function readConfig(documentRef: Document = document): SdkConfig {
  const current =
    documentRef.currentScript instanceof HTMLScriptElement ? documentRef.currentScript : null;
  const script =
    current ?? documentRef.querySelector<HTMLScriptElement>("script[data-vote-site-key]");
  const pageTitle = script?.dataset.votePageTitle?.trim();

  return {
    siteKey: script?.dataset.voteSiteKey ?? "unknown-site",
    endpoint: script?.dataset.voteEndpoint ?? "http://localhost:3000",
    ...(pageTitle === undefined || pageTitle === "" ? {} : { pageTitle }),
  };
}
